/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebhookEventNotificationResponseBaseBaseResponse as ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse } from '../../models/Models/Webhook/webhook-event-notification-response-base-base-response';
import { WebhookEventTestRequest as ModelsWebhookWebhookEventTestRequest } from '../../models/Models/Webhook/webhook-event-test-request';

export interface V3WebhooksCallbacktestPost$Plain$Params {
      body?: ModelsWebhookWebhookEventTestRequest
}

export function v3WebhooksCallbacktestPost$Plain(http: HttpClient, rootUrl: string, params?: V3WebhooksCallbacktestPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3WebhooksCallbacktestPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsWebhookWebhookEventNotificationResponseBaseBaseResponse>;
    })
  );
}

v3WebhooksCallbacktestPost$Plain.PATH = '/v3/webhooks/callbacktest';
